import { render, staticRenderFns } from "./addMenu.vue?vue&type=template&id=55b9312a&scoped=true&"
import script from "./addMenu.vue?vue&type=script&lang=js&"
export * from "./addMenu.vue?vue&type=script&lang=js&"
import style0 from "./addMenu.vue?vue&type=style&index=0&id=55b9312a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9312a",
  null
  
)

export default component.exports